import { defaultLanguage } from '../../../../../configs/LanguageConfig';
import chartingService from '../../../../../core/services/Technical/Charting';
import { getIndicatorHistoricalPeriod, setMultiplierByCode } from '../helper';
import moment from 'moment';

var prevTicker = '';
var prevPeriod = '';
var isLoop = true;
var object = {
  t: [],
  h: [],
  l: [],
  c: [],
};

export const ForeignTradingCode = 'ForeignTrading';

export const ForeignTrading = (PineJS, locale) => {
  const name = `FiinTrade - ${
    locale === defaultLanguage ? 'NDTNN' : 'Foreign Trading'
  }`;
  return {
    name: 'Foreign Trading',
    metainfo: {
      _metainfoVersion: 51,
      id: 'ForeignTrading@tv-basicstudies-1',
      name: name,
      description: name,
      shortDescription: name,
      is_hidden_study: false,
      is_price_study: false,
      isCustomIndicator: true,
      format: {
        type: 'volume',
        precision: 1,
      },
      plots: [
        { id: 'plot_0', type: 'line' },
        { id: 'plot_1', type: 'line' },
        { id: 'plot_2', type: 'line' },
      ],
      defaults: {
        styles: {
          plot_0: {
            linestyle: 0,
            linewidth: 1,
            plottype: 5,
            trackPrice: false,
            visible: true,
            transparency: 50,
            color: '#43A77D',
          },
          plot_1: {
            linestyle: 0,
            linewidth: 1,
            plottype: 5,
            trackPrice: false,
            visible: true,
            transparency: 50,
            color: '#E84855',
          },
          plot_2: {
            linestyle: 0,
            linewidth: 1,
            plottype: 0,
            trackPrice: false,
            visible: true,
            transparency: 0,
            color: '#F8C510',
          },
        },
        inputs: {},
      },
      styles: {
        plot_0: { title: 'Buy', histogramBase: 0, joinPoints: true },
        plot_1: { title: 'Sell', histogramBase: 0, joinPoints: true },
        plot_2: { title: 'Net', histogramBase: 0, joinPoints: true },
      },
      inputs: [],
    },
    constructor: function() {
      this.init = function(context, inputCallback) {
        this._context = context;
        this._input = inputCallback;
        var period = PineJS.Std.period(this._context);
        var ticker = PineJS.Std.ticker(this._context);
        var symbol = 'INDICATOR:ForeignTrading:' + ticker;
        this._context.new_sym(symbol, period);
        if (period.includes('W') || period.includes('M')) {
          var historicalSymbol = 'INDICATOR:ForeignTrading:' + ticker;
          this._context.new_sym(
            historicalSymbol,
            getIndicatorHistoricalPeriod(period),
          );
        }
        isLoop = true;
        object = {
          t: [],
          h: [],
          l: [],
          c: [],
        };
        if (prevPeriod !== period || prevTicker !== ticker) {
          prevPeriod = period;
          prevTicker = ticker;
        }
      };

      this.main = function(ctx, inputs) {
        this._context = ctx;
        this._input = inputs;
        this._context.select_sym(1);
        var period = PineJS.Std.period(this._context);
        var time = PineJS.Std.time(this._context, period);

        if (period.includes('W') || period.includes('M')) {
          this._context.select_sym(2);
          var timeHistory = this._context.new_var(
            PineJS.Std.time(
              this._context,
              getIndicatorHistoricalPeriod(period),
            ),
          );
          var fBuyHistory = this._context.new_var(
            PineJS.Std.high(this._context),
          );
          var fSellHistory = this._context.new_var(
            PineJS.Std.low(this._context),
          );
          var fNetHistory = this._context.new_var(
            PineJS.Std.close(this._context),
          );

          const timeHistoryCurrent = timeHistory.get(0);
          if (
            isLoop &&
            !PineJS.Std.na(timeHistoryCurrent) &&
            !object.t.includes(timeHistoryCurrent)
          ) {
            object.t.push(timeHistoryCurrent);
            object.h.push(fBuyHistory.get(0));
            object.l.push(fSellHistory.get(0));
            object.c.push(fNetHistory.get(0));
          }

          if (!PineJS.Std.na(time)) {
            this._context.select_sym(2);
            var lengthHistory = PineJS.Std.n(this._context);
            if (lengthHistory === object.t.length && isLoop) {
              isLoop = false;
            }

            var sumFBuy = 0;
            var sumFSell = 0;
            var sumFNet = 0;
            var count = 0;
            var indexOfTime = object.t.findIndex(val => val === time);
            var weekOfTime = moment(new Date(time)).week();
            var monthOfTime = new Date(time).getMonth() + 1;
            var yearOfTime = new Date(time).getFullYear();
            for (var x = indexOfTime; x < lengthHistory && x >= 0; x++) {
              if (period.includes('M')) {
                const month = new Date(object.t[x]).getMonth() + 1;
                const year = new Date(object.t[x]).getFullYear();
                switch (period) {
                  case '12M': {
                    if (yearOfTime === year) {
                      sumFBuy += object.h[x] || 0;
                      sumFSell += object.l[x] || 0;
                      sumFNet += object.c[x] || 0;
                    } else {
                      count++;
                    }
                    break;
                  }
                  case '3M': {
                    if (monthOfTime - 3 < month && yearOfTime === year) {
                      sumFBuy += object.h[x] || 0;
                      sumFSell += object.l[x] || 0;
                      sumFNet += object.c[x] || 0;
                    } else {
                      count++;
                    }
                    break;
                  }
                  default: {
                    if (monthOfTime === month && yearOfTime === year) {
                      sumFBuy += object.h[x] || 0;
                      sumFSell += object.l[x] || 0;
                      sumFNet += object.c[x] || 0;
                    } else {
                      count++;
                    }
                    break;
                  }
                }
                if (count > 0) break;
              } else if (period.includes('W')) {
                const week = moment(new Date(object.t[x])).week();
                const year = new Date(object.t[x]).getFullYear();
                if (weekOfTime === week && yearOfTime === year) {
                  sumFBuy += object.h[x] || 0;
                  sumFSell += object.l[x] || 0;
                  sumFNet += object.c[x] || 0;
                } else {
                  count++;
                }
                break;
              }
            }
          }
        }

        this._context.select_sym(1);
        return [
          { value: sumFBuy || PineJS.Std.high(this._context) },
          { value: sumFSell || PineJS.Std.low(this._context) },
          { value: sumFNet || PineJS.Std.close(this._context) },
        ];
      };
    },
  };
};

export const getForeignTradingFromApi = async (
  symbolInfo,
  resolution,
  from,
  to,
  getIndicatorParams,
) => {
  const newSymbolInfo = {
    ...symbolInfo,
    name: symbolInfo.name.replace(ForeignTradingCode, 'FOREIGN'),
  };

  const indicatorParams = getIndicatorParams(
    newSymbolInfo,
    resolution,
    from,
    to,
  );
  if (!indicatorParams) return null;

  const { items = [] } = await chartingService
    .getIndicator(indicatorParams)
    .then(data => data);

  const totalNetData = items.reduce(
    (total, item) => total + (item.fNet || 0),
    0,
  );

  let maxNumber = 0;
  const data = items
    .sort((a, b) => a.tradingDate.localeCompare(b.tradingDate))
    .map((item, index) => {
      if (Math.abs(item.fBuy) > maxNumber) {
        maxNumber = Math.abs(item.fBuy);
      }
      if (Math.abs(item.fSell) > maxNumber) {
        maxNumber = Math.abs(item.fSell);
      }
      if (Math.abs(item.fNet) > maxNumber) {
        maxNumber = Math.abs(item.fNet);
      }
      return {
        tradingDate: item.tradingDate,
        highestPrice: item.fBuy,
        lowestPrice: -item.fSell,
        closePrice: item.fNet,
        openPrice:
          index === 0 || index === items.length - 1
            ? totalNetData / items.length
            : 0,
        totalMatchVolume: 0,
      };
    });

  const [_, __, ticker] = symbolInfo.name.split(':');

  setMultiplierByCode({
    ticker,
    code: ForeignTradingCode,
    resolution,
    maxValue: maxNumber,
    isTrillion: false,
  });

  return { items: data };
};
